import { formatName } from 'utils/talent';

import { Grid } from '@mui/material';

import { Job, JobLocationTypeEnum, Skill } from '@libs/graphql-types';
import { isNil } from '@libs/helpers/common';
import { SkillChip } from '@libs/ui/components/chip';
import { formatDate, JOB_TYPE_MAP } from '@libs/ui/components/job/utils';
import { formatRate, getJobCapacity } from '@libs/ui/components/job/utils';
import { FINDERS_FEE_TOOLTIP } from '@libs/ui/components/job/utils';

import { DataGridItem } from './types';

export const mapJobToDataGridItems = (job?: Required<Job>): DataGridItem[] => {
  const isHibryd = job?.location_type === JobLocationTypeEnum.Hybrid;
  const daysInOffice: DataGridItem = {
    icon: 'period',
    title: 'Days in office',
    value: job?.office_hours_per_month,
  };
  const items: DataGridItem[] = [
    {
      title: 'Client',
      icon: 'client',
      value: job?.client || '-',
    },
    {
      icon: 'location',
      title: 'Country',
      value: job?.country || '-',
    },
    {
      icon: 'location',
      title: 'City',
      value: job?.city || '-',
    },

    {
      title: 'Type',
      value:
        JOB_TYPE_MAP[job?.location_type as keyof typeof JOB_TYPE_MAP] || '-',
      icon: 'calendar',
    },
    ...(isHibryd ? [daysInOffice] : []),
    {
      icon: 'euro',
      title: 'Hourly rate range',
      value: formatRate({
        min: job?.rate_min,
        max: job?.rate_max,
        period: 'hour',
        isNegotiable: job?.is_rate_negotiable,
      }),
    },
    {
      icon: 'speak',
      title: "Finder's fee",
      value: !isNil(job?.finders_fee)
        ? formatRate({
            min: job?.finders_fee,
            period: 'hour',
          })
        : '-',
      hint: FINDERS_FEE_TOOLTIP,
    },
    {
      icon: 'period',
      title: 'Starting date',
      value: job?.posted_at ? formatDate(job?.start_date) : '',
    },
    {
      icon: 'period',
      title: 'End date',
      value: job?.end_date ? formatDate(job?.end_date) : '-',
    },
    {
      title: 'Required Capacity',
      value: getJobCapacity(job as Job),
      icon: 'timelapse',
    },
    {
      title: 'Campaign owner',
      icon: 'owner',
      value:
        formatName({
          firstName: job?.campaign_owner?.first_name,
          lastName: job?.campaign_owner?.last_name,
        }) || '-',
    },
    {
      icon: 'book',
      title: 'Key skills',
      value: (
        <Grid container spacing={2}>
          {job?.skills?.map((skill) => (
            <Grid key={skill?.id} item>
              <SkillChip
                style={{
                  maxWidth: 240,
                  whiteSpace: 'nowrap',
                  textOverflow: 'ellipsis',
                }}
                size="small"
                skill={skill as Skill}
              />
            </Grid>
          ))}
        </Grid>
      ),
    },
  ];
  const finalItems = items.filter((i) => !isNil(i.value));

  return finalItems;
};
